// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9c8467e","732":"adcc515e","977":"d46185fb"}[chunkId] + ".chunk.js";
};